import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';
import { ChangeEventHandler } from 'react';

import { Checkbox } from '@flipster/react/design-system/checkbox';
import { hstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { perpAccountBunja } from './bunja/base';
import { formBunja } from './bunja/form';

const ReduceOnly = () => {
  const transAssets = useTranslations('Assets.r250401');
  const { symbol } = useBunja(tradeSymbolBunja);
  const { isOneWayAtom } = useBunja(perpAccountBunja);
  const { reduceOnlyAtom, priceTypeAtom, triggerTypeAtom } = useBunja(formBunja);
  const isOneWayMode = useAtomValue(isOneWayAtom);
  const [isReduceOnly, setIsReduceOnly] = useAtom(reduceOnlyAtom);
  const priceType = useAtomValue(priceTypeAtom);
  const triggerType = useAtomValue(triggerTypeAtom);

  const onChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const checked = Boolean(e.target.checked);
    setIsReduceOnly(checked);
    segment.track(TradeEvent.OrderReduceOnlyClick, {
      symbol,
      toggle_on: checked,
      order_type:
        priceType === 'market'
          ? 'market_order'
          : priceType === 'limit'
            ? 'limit_order'
            : triggerType === 'price'
              ? 'trigger_price_order'
              : 'trigger_time_order',
    });
  };

  if (!isOneWayMode) return null;

  return (
    <div className={hstack({ py: 8, gap: 8, alignItems: 'center' })}>
      <Checkbox
        checked={isReduceOnly}
        onChange={onChange}
        css={{ textStyle: 'Text/L/Strong', color: 'content.default.level-5' }}
      >
        {transAssets('Reduce_only')}
      </Checkbox>
    </div>
  );
};

export default ReduceOnly;
